module.exports = __webpack_public_path__ + "static/media/radiant-and-coolant-hoses-red.5500d719.svg";